import { ObjectLike } from '@/types/objectlike.types';
import serviceProvider from '@/services/service-provider';
import { iReview } from '@/entities/review/review.types';
import { watch } from '@vue/composition-api';
import usePaginator from '@/ui/composables/base/use-paginator';
import VueRouter from 'vue-router';

const COMMENTS_PER_PAGE = 5;
export default function useReviewFunctions(
  reviewVariables: ObjectLike,
  review: iReview,
  $router: VueRouter,
) {
  const {
    expandedText,
    showComment,
    comments,
    allComments,
    currentPage,
    maxPages,
  } = reviewVariables;

  const { paginate, calculatePages } = usePaginator();

  function toggleSeeMore() {
    expandedText.value = !expandedText.value;
  }

  function paginateComments() {
    const paginated = paginate(allComments.value, COMMENTS_PER_PAGE, currentPage.value);
    maxPages.value = calculatePages(allComments.value, COMMENTS_PER_PAGE);
    comments.value = [...comments.value, ...paginated];
  }

  async function fetchComments() {
    const results = await serviceProvider.review.getCommentsByReviewId(review.id);
    allComments.value = results;
    currentPage.value = 1;
    comments.value = [];
    paginateComments();
  }

  function toggleComment() {
    showComment.value = !showComment.value;
  }

  function seeMoreComments() {
    currentPage.value += 1;
    paginateComments();
  }

  function goToGamer() {
    $router.push({
      name: 'Profile',
      params: {
        id: review.userId,
      },
    }).catch();
  }

  function goToOriginalAuthor() {
    if (review.share) {
      $router.push({
        name: 'Profile',
        params: {
          id: review.share.reviewUserId,
        },
      }).catch();
    }
  }

  watch(
    () => showComment.value,
    (curr) => {
      if (curr) {
        fetchComments();
      }
    },
  );

  return {
    toggleComment,
    toggleSeeMore,
    fetchComments,
    seeMoreComments,
    goToGamer,
    goToOriginalAuthor,
  };
}
